import Tab from 'components/common/Tab'
import { constant } from 'constants/constant';
import React, { useState } from 'react'

import { Branch } from '../branch';
import CompanyProfile from '../companyProfile';
import { UserContext } from 'context';
import '../companySetting.css'

const Setting = () => {

    const [activeTab, setActiveTab] = useState(1);
    const { settingChild } = React.useContext(UserContext);
    const callBackTab = (data) => {
        setActiveTab(data);
    }

    const settingsTabProps = {
        tabList: settingChild,
        callBackTab: callBackTab,
        activeTab: activeTab
    }


    return (
        <div className='__settingNwd'>
            <div className='__setNw_left'>
                <div className='__setsHeads'><h4> Setting </h4></div>

                <Tab {...settingsTabProps} invoiceBillRaiseClass="__setNw_tabs" arrowIcon={true} section="setting"/>
            </div>

            <div className='__setNw_right'>
                {activeTab === "Company" && (
                    <CompanyProfile />
                )}

                {activeTab === 2 && (
                    // <div> Branch </div>
                    <Branch/>
                )}

                {activeTab === 3 && (
                    <div> Users </div>
                )}

                {activeTab === 4 && (
                    <div>Roles</div>
                )}

                {activeTab === 5 && (
                    <div> Eway Bill Access </div>
                )}

                {activeTab === 6 && (
                    <div> Subscription </div>
                )}

                {activeTab === 7 && (
                    <div> Route working </div>
                )}
            </div>
        </div>
    )
}

export default Setting